const setDragAndDrop = function (draggable) {
  draggable.style.cursor = 'move'
  draggable.style.position = 'absolute'
  var pos1 = 0
  var pos2 = 0
  var pos3 = 0
  var pos4 = 0
  draggable.onmousedown = mouseDown
  draggable.ontouchstart = mouseDown

  function mouseDown (e) {
    pos3 = e.clientX
    pos4 = e.clientY
    document.onmouseup = mouseUp
    document.onmousemove = mouseDrag
    draggable.ontouchend = mouseUp
    draggable.ontouchmove = touchDrag
  }

  function mouseDrag (e) {
    e.preventDefault()
    move(e.clientX, e.clientY)
  }

  function touchDrag (e) {
    if (e.targetTouches.length === 1) {
      e.preventDefault()
      var touch = e.targetTouches[0]
      move(touch.pageX, touch.pageY)
    }
  }

  function move (x, y) {
    pos1 = pos3 - x
    pos2 = pos4 - y
    pos3 = x
    pos4 = y
    draggable.style.top = (draggable.offsetTop - pos2) + 'px'
    draggable.style.left = (draggable.offsetLeft - pos1) + 'px'
  }

  function mouseUp (e) {
    document.onmouseup = null
    document.onmousemove = null
    draggable.ontouchend = null
    draggable.ontouchmove = null
  }
}

export {
  setDragAndDrop
}



// WEBPACK FOOTER //
// ./src/utils/common.js